var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.25V3.75C9.75 2.75544 9.35491 1.80161 8.65165 1.09835C7.94839 0.395088 6.99456 0 6 0C5.00544 0 4.05161 0.395088 3.34835 1.09835C2.64509 1.80161 2.25 2.75544 2.25 3.75V5.25C1.65326 5.25 1.08097 5.48705 0.65901 5.90901C0.237053 6.33097 0 6.90326 0 7.5V12.75C0 13.3467 0.237053 13.919 0.65901 14.341C1.08097 14.7629 1.65326 15 2.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V7.5C12 6.90326 11.7629 6.33097 11.341 5.90901C10.919 5.48705 10.3467 5.25 9.75 5.25ZM3.75 3.75C3.75 3.15326 3.98705 2.58097 4.40901 2.15901C4.83097 1.73705 5.40326 1.5 6 1.5C6.59674 1.5 7.16903 1.73705 7.59099 2.15901C8.01295 2.58097 8.25 3.15326 8.25 3.75V5.25H3.75V3.75ZM10.5 12.75C10.5 12.9489 10.421 13.1397 10.2803 13.2803C10.1397 13.421 9.94891 13.5 9.75 13.5H2.25C2.05109 13.5 1.86032 13.421 1.71967 13.2803C1.57902 13.1397 1.5 12.9489 1.5 12.75V7.5C1.5 7.30109 1.57902 7.11032 1.71967 6.96967C1.86032 6.82902 2.05109 6.75 2.25 6.75H9.75C9.94891 6.75 10.1397 6.82902 10.2803 6.96967C10.421 7.11032 10.5 7.30109 10.5 7.5V12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.a34473f2fed3ae5713e4e2a19eab01d7.svg";
export { ForwardRef as ReactComponent };